<div class="assign-leader-decom">
    <div class="row row-height margin-top-4">
        <div class="col-md-3 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
            <p class="headers-style"> Decom LOB </p>
            <p class="lob-name-padding-top">{{ decomlobName }}</p>
        </div>
        <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4 decom-lob-owner">
            <p class="headers-style"> Select Decom MBO Owner </p>
            <div class="leader-popup-width">
                <ng-container>
                    <mat-form-field appearance="fill" class="inline-form-edit sublob-edit-architects" floatLabel="never">
                        <p class="leader-input-align">
                            <input matInput class="leader-input" [matAutocomplete]="auto" [(ngModel)]="leaderName"
                                (keyup)="keyUpSearch($event)" placeholder="Search by Name/Mail">
                            <img class="search_Icon" src="../../../../assets/images/searchicon.png" style="position: relative;"/>
                        </p>
                    </mat-form-field>
                    <mat-autocomplete showPanel=true class="lob-options-list dropdown-width" #auto="matAutocomplete">
                        <mat-option [value]="'None'" (onSelectionChange)="selectionChanged(null, 'leader')"> None </mat-option>
                        <mat-option *ngFor="let user of users" (onSelectionChange)="selectionChanged(user, 'leader')"
                            title="{{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})" [value]="user.displayName">
                            {{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})
                        </mat-option>
                    </mat-autocomplete>
                </ng-container>
            </div>    
        </div>
    </div>
    <div class="row row-height">
        <div class="col-md-3 col-sm-6 col-lg-3 col-xl-3 col-xs-3">
            <p class="headers-style"> Decom Target Year </p>
            <div class="year-width">
                <mat-form-field appearance="outline" class="decom-target-width">
                    <mat-select [placeholder]="decomYear" [(ngModel)]="decomYear" (selectionChange)="selectionChanged(decomYear, 'decomYear')"
                        class="virtual-scroll" panelClass="dropdown-width" placeholder="Select Year">
                        <mat-option *ngFor="let option of YearsList" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-3 col-sm-6 col-lg-3 col-xl-3 col-xs-3 decom-target">
            <p class="headers-style"> Decom Target ( $ )</p>
            <mat-form-field appearance="outline" class="decom-target-width">
                <p class="leader-input-align"><input matInput type="number" [(ngModel)]="decomTarget" (ngModelChange)="selectionChanged(decomTarget, 'decomTarget')"></p>
            </mat-form-field>
        </div>
        <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
            <div>
                <p class="headers-style"> Comments </p>
                <div class="lob-assign-comments">
                    <mat-form-field appearance="outline">
                        <p class="comments-align"><textarea class="textarea-text" [(ngModel)]="comments" cols="100"
                            rows="4" maxlength="500" matInput placeholder="" (ngModelChange)="selectionChanged(comments, 'comments')">
                        </textarea></p>
                    </mat-form-field>
                </div>
            </div>
            <p class="maximum-text"> Maximum 500 Characters </p>
        </div>
    </div>
    <div class="row apply-style"> 
        <button mat-mdc-raised-button class="pull-right default-Button-Class m-1 uitk-c-button uitk-c-button--default 
            mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs" (click)="applyLeaderDecomMapping()"
            [disabled]="!enableApply">
            Apply
        </button>
    </div>
</div>